import { render } from "./YouthMode.vue?vue&type=template&id=7cff4a83&scoped=true"
import script from "./YouthMode.vue?vue&type=script&lang=js"
export * from "./YouthMode.vue?vue&type=script&lang=js"

import "./YouthMode.vue?vue&type=style&index=0&id=7cff4a83&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cff4a83"]])

export default __exports__